import React from "react";

const Payment = ({
  width = 36,
  height = 36,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4220_7769)">
        <rect x="2" y="1" width="32" height="32" rx="16" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          width="31"
          height="31"
          rx="15.5"
          stroke="#E2E4E9"
        />
        <path
          d="M18 9.5C22.14 9.5 25.5 12.86 25.5 17C25.5 21.14 22.14 24.5 18 24.5C13.86 24.5 10.5 21.14 10.5 17C10.5 12.86 13.86 9.5 18 9.5ZM18 23C21.315 23 24 20.315 24 17C24 13.685 21.315 11 18 11C14.685 11 12 13.685 12 17C12 20.315 14.685 23 18 23ZM18.75 17H21L18 20L15 17H17.25V14H18.75V17Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_7769"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_7769"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_7769"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Payment;
